import loadJs from "./libs/loadJs";
module.exports = loadJs;